import { useQuery } from '@tanstack/react-query'
import { api } from '../client'
import { chaves } from './chaves'
import type { PautaDoComite } from '../../types/cab'
import type { SolicitacoesDaJanela } from '../../types/gmud'

/**
 * A fila do comitê, com o apoio de cada item já reunido.
 *
 * Uma consulta só, e não uma por item: a tela precisa de parecer de IA e situação de revisão de PR
 * para SEIS solicitações ao mesmo tempo, e treze requisições em cascata numa reunião de uma hora é
 * a diferença entre a tela abrir e a tela travar no projetor.
 *
 * `staleTime` curto de propósito. A pauta muda a cada decisão tomada na própria reunião — e é
 * comum o presidente decidir num item e voltar para a lista.
 *
 * @returns a consulta da pauta
 */
export function usePautaDoComite() {
  return useQuery({
    queryKey: chaves.pautaDoComite(),
    queryFn: async () => {
      const { data } = await api.get<PautaDoComite>('/cab/pauta')
      return data
    },
    staleTime: 30 * 1000,
  })
}

/**
 * O que entra na próxima janela: as aprovadas e as que estão com o comitê.
 *
 * A chave mora sob `gmuds`, e não sob `cab`, porque é uma transição que faz a solicitação entrar ou
 * sair da janela — e toda transição invalida `chaves.gmuds()`. Sem o `staleTime` longo da janela:
 * a data muda de dia em dia, a lista muda a cada decisão do comitê.
 *
 * @returns a consulta
 */
export function useSolicitacoesDaProximaJanela() {
  return useQuery({
    queryKey: chaves.naProximaJanela(),
    queryFn: async () => {
      const { data } = await api.get<SolicitacoesDaJanela>('/cab/janela/solicitacoes')
      return data
    },
  })
}
